import { useMutation } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { AxiosError } from "axios";
import { useToast } from "@elton/ui/core";
import { useT } from "@transifex/react";
import { CompanySettings } from "@elton/types";
import { updateCompanySettings } from "@/api/requests/company-settings/update-company-settings.ts";

export const useUpdateCompanySettings = (companyId: string) => {
  const t = useT();
  const router = useRouter();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (data: CompanySettings) => updateCompanySettings(companyId, data),
    onSuccess: () => {
      toast({
        variant: "success",
        description: t("Settings were updated"),
      });
      router.invalidate();
    },
    onError: (err: AxiosError<{ message?: string }>) => {
      toast({
        variant: "error",
        description: `${t("Settings could not be updated")} ${err?.response?.data?.message ?? ""}`,
      });
    },
  });
};
